<template lang="pug">
.content.diamond-content
  .row.diamond-body
    .col-md-12
      .header Lịch sử điểm Diamond
      .col-md-3.box-content-left
        .card
          .card-content
            div
              img(src="../../assets/images/point/Mask Group 24.svg")
              .total-diamond {{formatNumber(totalDiamond)}}
      .col-md-9.box-content-right
        .card
          .card-content
            //- .col-md-9
            //-   EffectRank(:lstItems='itemRanks')
            //- .col-md-3
            div {{lstUserSameRank}}
    .col-md-12
      .card(style='margin-top:0')
        .card-content
          .box-list-diamond(v-if="!mobile")
            .box-diamond-header
              span STT
              span Hoạt động
              span Ngày giờ
            .box-diamond-scroll
              .box-diamond-items(v-for="(o, index) in diamondList")
                span {{index + 1}}
                span(v-if="!o.question_id") {{o.name}}
                  a.link-object(@click='onObject' v-if="o.grade") {{o.grade && o.grade.name}}
                  a.link-object(@click='onObject' v-else-if="o.competition") {{o.competition && o.competition.name}}
                  a.link-object(@click='onObject' v-else-if="o.subject") {{o.subject && o.subject.name}}
                  a.link-object(@click='onObject' v-else-if="o.qa_id") mã câu hỏi
                  a.link-object(v-else) ABCXYZ
                span(v-else-if="o.question_id") {{o.name}}
                  a.link-object(@click='onObject') câu hỏi 
                  | 50/50
                span(v-if="!o.question_id") , bạn được tặng 
                span(v-if="o.question_id") , bạn đã dùng 
                span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }} điểm
                span.minus(v-else) - {{ formatNumber(-o.amount) }} điểm
                |  diamond
                span {{ o.created_at | moment }}
              observer(@intersect="onIntersected")
          .box-list-diamond-kanban(v-else)
            .box-kanban-diamond-default(v-if="diamondList && diamondList.length === 0")
              div CHƯA CÓ HOẠT ĐỘNG DIAMOND
            .box-diamond-scroll-kanban(v-if="diamondList && diamondList.length > 0")
              .box-kanban-diamond(v-for="o in diamondList")
                div(v-if="!o.question_id") {{o.name}}
                  a.link-object(@click='onObject' v-if="o.grade") {{o.grade && o.grade.name}}
                  a.link-object(@click='onObject' v-else-if="o.competition") {{o.competition && o.competition.name}}
                  a.link-object(@click='onObject' v-else-if="o.subject") {{o.subject && o.subject.name}}
                  a.link-object(@click='onObject' v-else-if="o.qa_id") mã câu hỏi
                  a.link-object(v-else) ABCXYZ
                  span(v-if="!o.question_id") , bạn được tặng 
                  span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }} điểm
                  span.minus(v-else) - {{ formatNumber(-o.amount) }} điểm
                  |  diamond
                div(v-else-if="o.question_id") {{o.name}}
                  a.link-object(@click='onObject') câu hỏi 
                  | 50/50
                  span(v-if="o.question_id") , bạn đã dùng 
                  span.plus(v-if="o.amount > 0") + {{ formatNumber(o.amount) }} điểm
                  span.minus(v-else) - {{ formatNumber(-o.amount) }} điểm
                  |  diamond
                div {{ o.created_at | moment }}
            observer(@intersect="onIntersected")
          //- .box-diamond-pagination
          //-   span PHÂN TRANG DANH SÁCH
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import moment from 'moment'
import Observer from '../Point/Observer'
import store from '../../store'
import EffectRank from './effectRank'

export default {
  components: {
    Observer,
    EffectRank
  },
  data() {
    return {
      diamondList: {
        type: Array,
        default: () => ([])
      },
      totalDiamond: 0,
      items: [],
      points: [],
      offset: 10,
      limit: 10,
      infoUserRank: [],
      lstUserSameRank: null,
      itemRanks: [],
      mobile: false
    }
  },
  methods: {
    onObject(index) {
      // console.log('competition: ', index)
    },
    formatNumber(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async getDiamonds(offset, limit) {
      await this.$apollo.query({
        query: gql(graphql.GET_POINTS_USER),
        variables: {
          uid: this.$store.getters.user,
          offset: offset,
          limit: limit,
          type: 2
        }
      }).then((res) => {
        if (res) {
          // console.log(res.data.history_point)
          this.points = res.data.history_point
        }
      })
    },
    async onIntersected() {
      // console.log(this.offset, this.limit)
      await this.getDiamonds(this.offset, this.limit)
      this.offset += 10
      this.diamondList = [...this.diamondList, ...this.points]
    }
  },
  filters: {
    moment(date) {
      return moment(date).format('DD/MM/YYYY hh:mm') // format (h:mm:ss a)
    }
  },
  apollo: {
    ItemRanks: {
      query: gql(graphql.GET_RANK),
      update: data => {
        // console.log(data)
        return data.rank
      }
    },
    diamondList: {
      query: gql(graphql.GET_POINTS_USER),
      variables() {
        return {
          uid: this.$store.getters.user,
          type: 2,
          offset: 0,
          limit: 10
        }
      },
      update: data => data.history_point
    },
    totalDiamond: {
      query: gql(graphql.COUNT_POINT_USER),
      variables() {
        return {
          uid: this.$store.getters.user,
          type: 2
        }
      },
      update: data => data.history_point_aggregate.aggregate.sum.amount,
      skip() {
        return this.$store.getters.user == null
      }
    },
    lstUserSameRank: {
      query: gql(graphql.GET_USER_SAME_RANK),
      variables() {
        return {
          rank_id: this.$route && this.$route.params && this.$route.params.rank_id || store.getters.fullname && store.getters.fullname.rank_id
        }
      },
      fetchPolicy: 'no-cache',
      update: data => {
        if (data.v_user_public && data.v_user_public.length > 0) {
          if (data.v_user_public.length <= 1) {
            return 'Bạn là người duy nhất đạt thứ hạng này'
          } else {
            var infoUserRank = ['Bạn']
            var countTotal = 0
            var diff = 0
            // console.log(data.v_user_public)
            for (var i = 0; i < data.v_user_public.length; i++) {
              var fullname = data.v_user_public[i].fullname
              countTotal++
              if (data.v_user_public[i].id !== store.getters.user) {
                if (countTotal < 3) infoUserRank.push(fullname)
                else diff++
              }
            }
            infoUserRank = infoUserRank.join(', ')
            return infoUserRank + ' và ' + diff + ' người khác đã đạt thứ hạng này'
          }
        }
        return null
      }
    }
  },
  mounted() {
    if (window.innerWidth < 991) {
      this.mobile = true
    } else {
      this.mobile = false
    }
  },
  created() {
    this.$store.commit('setIsHomePage', false)
  }
}
</script>
<style lang="scss">
.diamond-content {
  padding-top: 20px !important;
}
.diamond-body {
  .header {
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #5F6468;
  }
  .box-content-left {
    padding-left: 0px;
    // padding-right: 10px;
    .card {
      margin-top: 15px;
      margin-bottom: 15px;
      width: 184px;
      height: 164px;
      border-radius: 0px;
      .card-content {
        div {
          text-align: center;
          width: 100%;
          height: auto;
          img {width: 100px; height: 100px;}
          .total-diamond {font-size: 24px; font-weight: bold; color: #4B2D15; padding-top: 10px;}
        }
      }
    }
  }
  .box-content-right {
    position: absolute;
    padding: 0;
    .card {
      margin-top: 15px;
      margin-bottom: 15px;
      margin-left: 200px;
      border-radius: 0px;
      .card-content {
        .carousel-3d-container {
          height: 100px !important;
          .carousel-3d-slider {
            height: 100px !important;
            .carousel-3d-slide {}
          }
        }
      }
    }
  }
  .card {
    .card-content {
      .box-list-diamond {
        .box-diamond-header {
            padding: 10px 0;
            font-size: 15px;
            font-weight: bold;
            font-family: 'Helvetica' sans-serif;
            span:nth-child(2) {padding-left: 30px;}
            span:last-child {float:right;padding-right: 110px;}
        }
        .box-diamond-scroll {
          overflow-y: scroll;
          height: 520px;
          &::-webkit-scrollbar {
            width: 10px;
	          background-color: #F5F5F5;
          }
          &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	          background-color: #F5F5F5;
	          border-radius: 10px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 10px;
	          // background-image: -webkit-gradient(linear,
						// 			   left bottom,
						// 			   left top,
						// 			   color-stop(0.44, rgb(122,153,217)),
						// 			   color-stop(0.72, rgb(73,125,189)),
						// 			   color-stop(0.86, rgb(28,58,148)));

            background-color: #F90;	
	          background-image: -webkit-linear-gradient(45deg,rgba(255, 255, 255, .2) 25%,
											  transparent 25%,
											  transparent 50%,
											  rgba(255, 255, 255, .2) 50%,
											  rgba(255, 255, 255, .2) 75%,
											  transparent 75%,
											  transparent)
          }

          /* Handle on hover */
          &::-webkit-scrollbar-thumb:hover {
            background: #555; 
          }
          .box-diamond-items {
            border-top: 1px solid #00000029;
            padding: 20px 0 10px;
            position: relative;
            &:nth-last-child(1) {border-bottom: 1px solid #00000029;}
            span:first-child {position: absolute;}
            span:nth-child(2) {
              padding-left: 58px;
              a.link-object {color: #1A0DAB; cursor: pointer;}
            }
            span.plus {color: #3A9F00;}
            span.minus {color: #D63131;}
            span:last-child {position: absolute; right: 50px;}
          }
        }
      }
      .box-list-diamond-kanban {
        .box-kanban-diamond-default {display: none;}
        .box-kanban-diamond {display:none;}
      }
      .box-diamond-pagination {}
    }
  }
}
@media (max-width: 414px) {
  .diamond-content {
    padding-top: 30px !important;
  }
  .diamond-body {
    .box-content-left {
      padding: 0;
      .card {
        width: 100%;
        height: auto;
        border-radius: 5px;
        .card-content {
          padding-top: 8px;
          padding-bottom: 10px;
          padding-left: 15px;
          div {
            text-align: left;
            // padding-bottom: 10px;
            position: relative;
            img {width: 32px; height: auto; position: absolute;}
            .total-diamond {font-size: 24px; font-weight: bold; color: #4B2D15;display: block;padding-top: 5px; padding-left: 52px;}
          }
        }
      }      
    }
    .box-content-right {
      position: inherit;
      .card {
        margin-left: 0;
        margin-top: 0;
        margin-bottom: 10px;
        border-radius: 5px;
      }
    }
    .card {
      .card-content {
        .box-list-diamond {
          .box-diamond-header {display: none;}
          .box-diamond-scroll {display: none;}
        }
        .box-list-diamond-kanban {
          .box-kanban-diamond-default {
            display: block;
            width: 100%;
            height: auto;
            font-weight: bold;
            background-color: #FAFAFA;
            padding: 10px;
            border-radius: 5px;
            border: 1px solid #E0E0E0;
            opacity: 1;
            font-size: 15px;
          }
          .box-diamond-scroll-kanban {
            overflow-y: scroll;
            height: 300px;
            &::-webkit-scrollbar {
              width: 10px;
              background-color: #F5F5F5;
            }
            &::-webkit-scrollbar-track {
              -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
              background-color: #F5F5F5;
              border-radius: 10px;
            }
            &::-webkit-scrollbar-thumb {
              border-radius: 10px;
              // background-image: -webkit-gradient(linear,
              // 			   left bottom,
              // 			   left top,
              // 			   color-stop(0.44, rgb(122,153,217)),
              // 			   color-stop(0.72, rgb(73,125,189)),
              // 			   color-stop(0.86, rgb(28,58,148)));

              background-color: #F90;	
              background-image: -webkit-linear-gradient(45deg,rgba(255, 255, 255, .2) 25%,
                          transparent 25%,
                          transparent 50%,
                          rgba(255, 255, 255, .2) 50%,
                          rgba(255, 255, 255, .2) 75%,
                          transparent 75%,
                          transparent)
            }

            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
              background: #555; 
            }
            .box-kanban-diamond {
              display: block;
              width: 100%;
              height: auto;
              background-color: #FAFAFA;
              padding: 10px;
              border-radius: 5px;
              border: 1px solid #E0E0E0;
              opacity: 1;
              font-size: 15px;
              margin: 5px 0 10px;
              &:last-child {margin: 5px 0 5px;}
              div:first-child {
                padding-bottom: 5px;
                a.link-object {color: #1A0DAB;}
                span.plus {color: #3A9F00;}
                span.minus {color: #D63131;}
              }
              div:nth-child(2) {color:#969FAD;}
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Diamond.vue?3fca189c